import { Button, Stack } from "@mantine/core";
import { SimpleBreadcrumbs } from "../../components/SimpleBreadcrumbs";
import { FullPageLoader } from "../../components/FullPageLoader";
import { ActionCard } from "../../components/ActionCard";
import { useDisclosure } from "@mantine/hooks";
import { ProviderType } from "@project/common";
import { ChangePasswordModal } from "./components/ChangePasswordModal";
import { SetupPasswordModal } from "./components/SetupPasswordModal";
import { FormattedMessage, useIntl } from "react-intl";
import { useUser } from "../../hooks/user";

export const Authentication = () => {
  const intl = useIntl();
  const user = useUser();

  const [
    opened,
    {
      open,
      close,
    },
  ] = useDisclosure(false);

  if (!user) {
    return <FullPageLoader />;
  }

  return (
    <Stack gap={16} h="100%">
      <SimpleBreadcrumbs
        parent={intl.formatMessage({ defaultMessage: "Manage profile", id: "navigation.manageProfile" })}
        current={intl.formatMessage({ defaultMessage: "Authentication", id: "navigation.authentication" })}
        description={intl.formatMessage({ defaultMessage: "Change password, two-factor authentication and other security settings.", id: "text.authenticationDescription" })}
      />
      {user.providers.find(provider => provider.type === ProviderType.Email) && (
        <>
          <ActionCard
            title={intl.formatMessage({ defaultMessage: "Password", id: "title.password" })}
            subTitle={intl.formatMessage({ defaultMessage: "Change your password any time", id: "text.passwordChangeDescription" })}
          >
            <Button onClick={open} variant="primary">
              <FormattedMessage defaultMessage="Change password" id="button.changePassword" />
            </Button>
          </ActionCard>

          <ChangePasswordModal
            open={opened}
            onClose={close}
          />
        </>
      )}
      {!user.providers.find(provider => provider.type === ProviderType.Email) && (
        <>
          <ActionCard
            title={intl.formatMessage({ defaultMessage: "Password", id: "title.password" })}
            subTitle={intl.formatMessage({ defaultMessage: "Add password to you account. You will be able to sign in with email and password.", id: "text.addPasswordDescription" })}
          >
            <Button onClick={open} variant="primary">
              <FormattedMessage defaultMessage="Setup password" id="button.setupPassword" />
            </Button>
          </ActionCard>

          <SetupPasswordModal
            open={opened}
            onClose={close}
          />
        </>
      )}
    </Stack>
  );
};
